import React from 'react';

export const hasAnyPermission = (permissions: string[] | undefined | null, hasAnyPermissions: string[]) => {
  if (permissions && Array.isArray(permissions) && permissions.length !== 0) {
    return (hasAnyPermissions.length === 0) || hasAnyPermissions.some(auth => permissions.includes(auth));
  }
  return false;
};
